"use client";

import React, { FC, RefObject, useEffect } from "react";

import useBreakPoint from "@/hooks/useBreakpoint";

import { HistorySlideCard } from "./HistoryCard";
import { History, HistoryCard } from "./types";

interface Props {
  data: History;
  carouselRef: RefObject<HTMLDivElement>;
  actionTriggerByBullet?: boolean;

  setOpenModalCard: Function;
  setCurrentYearGroupIndex: Function;
  setCurrentCard: Function;
  setCurrentBulletIndex: Function;
  cardsList: {
    yearGroupIndex: number;
    card: HistoryCard;
  }[];
}
const HistoryDesktop: FC<Props> = ({
  data,
  carouselRef,
  cardsList,
  setOpenModalCard,
  setCurrentYearGroupIndex,
  setCurrentCard,
  setCurrentBulletIndex,
}) => {
  const { isMd } = useBreakPoint("md");

  function addMarginToCenterEdgesCards() {
    const cards = carouselRef.current?.querySelectorAll(".swiper-slide");
    const headerHeight = document.querySelector("#header-desktop")?.getBoundingClientRect().height;
    if (cards?.[0]) {
      let marginTop = window.innerHeight / 2 - cards[0].getBoundingClientRect().height / 2;
      if (headerHeight && marginTop <= headerHeight) {
        marginTop = headerHeight + 24;
      }
      //@ts-ignore
      cards[0].style.marginTop = marginTop + "px";
      if (cards.length > 1) {
        //@ts-ignore
        cards[cards.length - 1].style.marginBottom = window.innerHeight / 2 - cards[cards.length - 1].getBoundingClientRect().height / 2 + "px";
      }
    }
  }

  function createObserver() {
    const callback: IntersectionObserverCallback = (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        const yearGroupIndex = entry.target.parentElement?.getAttribute("data-year-index");
        const cardRealIndex = entry.target.parentElement?.getAttribute("data-card-index");
        if (yearGroupIndex) {
          setCurrentYearGroupIndex(+yearGroupIndex);
          setCurrentBulletIndex(undefined);
        }
        if (cardRealIndex) setCurrentCard(cardsList[+cardRealIndex]?.card);
      }
    };
    const targets = carouselRef.current?.querySelectorAll(".swiper-slide .observer-target");

    const observer = new IntersectionObserver(callback, { threshold: 0, rootMargin: "-50% 0px -50% 0px" });
    targets?.forEach((el) => observer.observe(el));
  }
  useEffect(() => {
    if (isMd) {
      addMarginToCenterEdgesCards();
      createObserver();
    }
  }, [isMd]);

  return isMd ? (
    <>
      <div className="relative w-full order-2 md:order-1 history-card-carousel flex flex-col gap-l" ref={carouselRef}>
        {cardsList?.map((item, index) => {
          return (
            <div
              key={item.yearGroupIndex + "-" + index}
              className="relative swiper-slide"
              data-year-index={item.yearGroupIndex}
              data-card-index={index}
            >
              <span className="observer-target absolute top-2/4 h-4xl w-full hidden md:block z-10 -translate-y-2/4 pointer-events-none"></span>
              <HistorySlideCard card={item.card} index={index} year={data.years[item.yearGroupIndex].year} setOpenModalCard={setOpenModalCard} />
            </div>
          );
        })}
      </div>
    </>
  ) : (
    <></>
  );
};
export default HistoryDesktop;
